import { z } from "zod";

import { withZod } from "@rvf/zod";

/**
 * `POST /resources/reorder` — re-add a past order's items to the basket
 * (COM-48).
 *
 * Exported as `RESOURCE_URL` to match `schemas/basket.ts`'s shape, and aliased
 * because `BasketProvider` imports both side by side to decide whether an
 * in-flight POST invalidates the shared basket snapshot
 * (`resources/basket.tsx`). Keep the alias — an unaliased second `RESOURCE_URL`
 * in that file would shadow confusingly.
 */
export const RESOURCE_URL = "/resources/reorder";
export { RESOURCE_URL as REORDER_RESOURCE_URL };

export const ReorderSchema = z.object({
  /**
   * The SFCC order number, NOT the SOM `orderSummaryId`. SFRA's own reorder
   * button passes `order.sfccOrderNumber` (`somorderDetails.isml:33-40`), and
   * SCAPI `shopperOrders.getOrder` is keyed on `orderNo` — so the two agree.
   * Bounded because it lands straight in an upstream path segment.
   */
  orderNo: z
    .string()
    .trim()
    .min(1)
    .max(128)
    /* SFCC order numbers are alphanumeric with optional separators. The SDK
       url-encodes path params, so this is not a traversal guard — it just turns
       a garbage submit into a 422 instead of a wasted SCAPI round trip. */
    .regex(/^[A-Za-z0-9_-]+$/),
});

export const ReorderValidator = withZod(ReorderSchema);
